import React from 'react'

import appStoreBadge from '@assets/app-store-badge.svg'
import googlePlayBadge from '@assets/google-play-badge.svg'
import { ModalBox, useModalContext } from '@fourthwall/components'
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links'

import * as S from './ThankYousNotSupported.styled'

export const ThankYousNotSupported = () => {
  const { close } = useModalContext()

  return (
    <ModalBox onClose={close} size="small" title="Browser not supported">
      <>
        Your current operating system and browser combination doesn’t support recording thank yous
        at the moment. While our team is working on a fix, you can try to use other browsers or our
        mobile app to record thank yous.
        <S.MobileAppContainer>
          <div>
            <S.MobileAppLink href={MOBILE_APP_IOS_LINK} target="_blank" rel="noreferrer">
              <S.MobileAppImage src={appStoreBadge} alt="App Store Badge" />
            </S.MobileAppLink>
          </div>
          <div>
            <S.MobileAppLink href={MOBILE_APP_ANDROID_LINK} target="_blank" rel="noreferrer">
              <S.MobileAppImage src={googlePlayBadge} alt="Google Play Badge" />
            </S.MobileAppLink>
          </div>
        </S.MobileAppContainer>
      </>
    </ModalBox>
  )
}
